import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=5565383e&scoped=true"
import script from "./ValidateEmail.vue?vue&type=script&lang=js"
export * from "./ValidateEmail.vue?vue&type=script&lang=js"
import style0 from "./ValidateEmail.vue?vue&type=style&index=0&id=5565383e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565383e",
  null
  
)

export default component.exports